import {
  CreateQuestion as CreateQuestionType,
  UpdateQuestion as UpdateQuestionType,
  StatusLabels,
  QuestionStatusChangeResponse,
} from '@plugins/faq-lib/types';
import { Subscription } from '@plugins/shared/types';
import type { Filter } from '@plugins/shared/types/post/filter';

export class LoadQuestions {
  static readonly type = '[Question] Load questions';
  constructor(public skip?: number) {}
}

export class LoadMoreQuestions {
  static readonly type = '[Question] Load more questions';
  constructor() {}
}

export class GetQuestionDetails {
  static readonly type = '[Question] Get question with details';
  constructor(
    public questionId: string,
    public skipAnswers?: number,
    public takeAnswers?: number,
  ) {}
}

export class CreateQuestion {
  static readonly type = '[Question] Create question';
  constructor(public question: CreateQuestionType) {}
}

export class UpdateQuestion {
  static readonly type = '[Question] Update question';
  constructor(public question: UpdateQuestionType) {}
}

export class LikeQuestion {
  static readonly type = '[Question] Like question';
  constructor(public questionId: string) {}
}

export class DeleteQuestion {
  static readonly type = '[Question] Delete question';
  constructor(public questionId: string) {}
}

export class DeleteFilteredQuestions {
  static readonly type = '[Question] Delete filtered questions';
  constructor() {}
}

export class DeleteAllQuestions {
  static readonly type = '[Question] Delete all questions';
  constructor() {}
}

export class ChangeQuestionStatus {
  static readonly type = '[Question] Change question status';
  constructor(
    public questionId: string,
    public status: StatusLabels,
  ) {}
}

export class AnswerCreated {
  static readonly type = '[Question] Answer created';
  constructor(
    public questionId: string,
    public subscription: Subscription,
  ) {}
}

export class AnswerDeleted {
  static readonly type = '[Question] Answer deleted';
  constructor(public question: QuestionStatusChangeResponse) {}
}

export class ChangeQuestionsFilter {
  static readonly type = '[Question] Change questions filter';
  constructor(public filter: Partial<Filter>) {}
}

export class ResetQuestionsFilter {
  static readonly type = '[Question] Reset questions filter';
  constructor() {}
}

export class ExportQuestions {
  static readonly type = '[Question] Export questions';
  constructor(
    public anonymousMode = false,
    public profileFields: string[],
  ) {}
}

export class SetOverviewQuestionAnchor {
  static readonly type = '[Question] Set overview question anchor';
  constructor(public questionId: string) {}
}

export class UnsetOverviewQuestionAnchor {
  static readonly type = '[question] Unset overview question anchor';
  constructor() {}
}

export class QuestionSubscribe {
  static readonly type = '[Question] Subscribe';
  constructor(public questionId: string) {}
}

export class QuestionUnsubscribe {
  static readonly type = '[Question] Unsubscribe';
  constructor(public questionId: string) {}
}
